import { render } from "./PqrRichEditor.vue?vue&type=template&id=5d7c8d48"
import script from "./PqrRichEditor.vue?vue&type=script&lang=js"
export * from "./PqrRichEditor.vue?vue&type=script&lang=js"

import "./PqrRichEditor.vue?vue&type=style&index=0&id=5d7c8d48&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__